import React from 'react'
import { Router, Route, IndexRoute } from 'react-router'
import App from './components/App'
import Regulation from './components/Regulation'

require('./assets/styles/main.scss')

module.exports = (
  <Router>
    <Route path="/" component={App}>
      <IndexRoute component={App} />
    </Route>
    <Route path="/Regulation" component={Regulation}>
      <IndexRoute component={Regulation} />
    </Route>
  </Router>
)



// WEBPACK FOOTER //
// ./client/routes.js